// schema
// import * as ISchema from '@schema';

// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";

// internal
import * as s from "./PaymentConfirmation.styles";
import { IProps, IState, IContainer } from "./PaymentConfirmation.d";
import { paymentConfirmationFragments } from "./PaymentConfirmation.gql";

// other components
// import { TeamPicker } from '@components/team-picker';
import { H1 } from "@ui";

// util
import { maybeGetPrimaryTeamFromOrg } from "@util/team.util";
// import { logger } from '@util/logger.util';
import { page, PageEvents, track, TrackingEvents } from "@util/analytics.util";
import { windowLocation } from "@util/location.util";

// state
import { setPricingDialogOpen, updateShouldRefetch } from "@actions/payments.actions";

// constants

// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import { Button } from "@material-ui/core";

class PaymentConfirmationCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    const maybePrimaryTeam = maybeGetPrimaryTeamFromOrg(props.org);
    const primaryTeamId = maybePrimaryTeam ? maybePrimaryTeam.teamId : "";

    this.state = {
      selectedTeamId: props.team ? props.team.teamId : primaryTeamId,
      loading: false,
    };
  }

  // ~-~-~-~-~-~-~-
  // Lifecycle
  // ~-~-~-~-~-~-~-
  public componentDidMount() {
    page(PageEvents.PAYMENT_CONFIRMATION);
    this.props.updateShouldRefetch(true);
  }

  // ~-~-~-~-~-~-~-
  // Handlers
  // ~-~-~-~-~-~-~-
  private onPaymentConfirmationGotItClicked = () => {
    track(TrackingEvents.CHECKOUT.PAYMENT_CONFIRMATION_GOT_IT_CLICKED);
    this.setState({ loading: true });
    if (!this.props.isDialog) {
      windowLocation.assign("PaymentConfirmationGotItClicked", "/app");
    } else {
      this.props.setPricingDialogOpen(false);
    }
  };

  // private onSelectTeam = (teamId: string) => {
  //   this.setState({ selectedTeamId: teamId });
  //   if (this.props.onChangeTeam) {
  //     this.props.onChangeTeam(teamId);
  //   }

  //   track(TrackingEvents.CHECKOUT.SELECT_TEAM, { teamId });
  // }

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  private renderOrgCheckoutConfirmation = () => {
    const { classes } = this.props;

    return (
      <div className={classes.subscriptionConfirmation}>
        {/* <div style={{ width: 150 }}>
          <TeamPicker
            userTeams={userTeams}
            teamId={selectedTeamId}
            label="Team"
            onChange={this.onSelectTeam}
            primaryTeamId={primaryTeamId}
            hidePrimaryIndicator
            inlineStyles
            />
        </div> */}
        <H1 style={{ fontSize: 60, paddingBottom: 0, marginBottom: 0 }}>🙌🏽</H1>
        <H1 style={{ fontSize: 30, marginBottom: 0 }}>Congratulations!</H1>
        <div className={classes.subscriptionConfirmationDescription}>
          You are now upgraded and will get a payment confirmation shortly!
        </div>
        <Button
          style={{ margin: "0 auto", marginTop: 15, fontSize: 16, height: 50, width: 150 }}
          onClick={() => this.onPaymentConfirmationGotItClicked()}
          variant="contained"
          color="primary"
          disabled={this.state.loading}
        >
          Got it
        </Button>
      </div>
    );
  };

  public render() {
    // const { selectedTeamId } = this.state;
    // return (
    //   <div>
    //     <div className={props.classes.lineItem}>
    //       <div className="label">
    //         Payment method
    //       </div>
    //       <div className="sub-label">
    //         {getPaymentMethodInfoFromTeam(team)}
    //       </div>
    //       <div className="action">
    //         <Button variant="contained" color="primary" onClick={setRoute(CheckoutFormRoute.ManagePayment)}>Update</Button>
    //       </div>
    //     </div>
    //     <div className={props.classes.lineItem}>
    //       <div className="label">
    //         Billing interval
    //       </div>
    //       <div className="sub-label">
    //         {reduxState.subscriptionInterval}
    //       </div>
    //     </div>
    //     <div style={{ textAlign: 'right' }}>
    //       <Button
    //         style={{ display: 'inline-block', backgroundColor: colors.red.standard }}
    //         variant="contained"
    //         color="primary"
    //         onClick={clearPaymentInfo}
    //         >
    //         Cancel Subscription
    //       </Button>
    //     </div>
    //   </div>
    // );

    // const userTeams = org.userTeams.__typename === 'TeamList' ? org.userTeams : null;

    // if (!userTeams) {
    //   logger.error('failed to fetch userTeams for CheckoutForm');
    //   return '';
    // }

    // const maybePrimaryTeam = maybeGetPrimaryTeamFromOrg(org);
    // const primaryTeamId = maybePrimaryTeam ? maybePrimaryTeam.teamId : '';

    return this.renderOrgCheckoutConfirmation();
  }
}

/////////////////
// With Styles //
/////////////////

const PaymentConfirmationStyled = withStyles(s.styles)(PaymentConfirmationCmpt);

///////////
// Redux //
///////////

function mapStateToProps(_state: any, _ownProps: IContainer) {
  return {}; // add redux state here, if needed
}

const reduxContainer = connect(mapStateToProps, {
  setPricingDialogOpen,
  updateShouldRefetch,
})(PaymentConfirmationStyled);

///////////
// Relay //
///////////

export const PaymentConfirmation = createFragmentContainer<IContainer>(
  reduxContainer,
  paymentConfirmationFragments,
);
